/*jshint esversion: 6 */
import axios from 'axios';
import store from './store';

// Configuració dels timeouts i retries
const TIMEOUT = 10000; // 10 segons
const MAX_RETRIES = 3;
const RETRY_DELAY = 2000; // 2 segons

// Configuració global d'axios
axios.defaults.timeout = TIMEOUT;

// Interceptor de peticions
axios.interceptors.request.use(
  (config) => {
    // Afegir headers necessaris
    const empresa = getEmp();
    if (empresa) {
      config.headers = config.headers || {};
      config.headers.Empresa = empresa;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respostes
axios.interceptors.response.use(
  (response) => {
    // Si la resposta és correcta, amagar el diàleg d'error si estava visible
    store.commit('hideConnectionError');
    return response;
  },
  (error) => {
    // Comprovar si és un error 409 (Conflict) abans de gestionar-lo
    if (error.response && error.response.status === 409) {
      // Permetre que el component gestioni l'error 409
      return Promise.reject(error);
    }
    
    // Comprovar si la petició té el flag per saltar el diàleg d'error
    if (error.config && error.config.skipErrorDialog) {
      return Promise.reject(error);
    }
    
    // Per altres errors, usar la gestió centralitzada
    handleConnectionError(error);
    return Promise.reject(error);
  }
);

// Funció per gestionar errors de connexió
function handleConnectionError(error) {
  let errorMessage = '';
  let errorType = 'network';

  if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
    errorMessage = 'Temps d\'espera superat. Comprova la connexió de xarxa.';
    errorType = 'timeout';
  } else if (error.response) {
    // El servidor ha respost amb un error
    if (error.response.status >= 500) {
      errorMessage = 'Error del servidor. Torna-ho a provar en uns moments.';
      errorType = 'server';
    } else if (error.response.status === 404) {
      errorMessage = 'Recurs no trobat. Comprova la configuració.';
      errorType = 'notfound';
    } else if (error.response.status === 401) {
      errorMessage = 'Sessió caducada. Torna a iniciar sessió.';
      errorType = 'auth';
    } else {
      errorMessage = `Error ${error.response.status}: ${error.response.statusText}`;
      errorType = 'http';
    }
  } else if (error.request) {
    // No s'ha rebut resposta del servidor
    errorMessage = 'No s\'ha pogut connectar amb el servidor. Comprova la connexió de xarxa.';
    errorType = 'network';
  } else {
    errorMessage = 'Error inesperat: ' + error.message;
    errorType = 'unknown';
  }

  // Mostrar el diàleg d'error
  store.commit('showConnectionError', {
    message: errorMessage,
    type: errorType,
    canRetry: ['network', 'timeout', 'server'].includes(errorType)
  });
}

// Funció per fer retry d'una petició
async function retryRequest(originalRequest, retryCount = 0) {
  if (retryCount >= MAX_RETRIES) {
    throw new Error('Màxim de reintents superat');
  }

  await new Promise(resolve => setTimeout(resolve, RETRY_DELAY * (retryCount + 1)));
  
  try {
    return await axios.request(originalRequest);
  } catch (error) {
    return retryRequest(originalRequest, retryCount + 1);
  }
}

// Funció auxiliar per obtenir l'empresa
function getEmp() {
  let urlParams = new URLSearchParams(window.location.search);
  let empresa = urlParams.get('e');
  
  if (!empresa) empresa = 1;

  return empresa;
}

export { retryRequest };
export default axios;
